(() => {
  const KEY = 'lb_recently_viewed_products';
  const MAX = 24;

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch {
      return String(url || '').split('?')[0].replace(/\/$/, '');
    }
  }

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveCurrentProduct() {
    const product = window.LB_CURRENT_PRODUCT;

    if (!product || !product.url) return;

    const currentUrl = normalizeUrl(product.url);

    const items = getItems().filter((item) => {
      return normalizeUrl(item.url) !== currentUrl;
    });

    items.unshift({
      handle: product.handle || '',
      url: currentUrl,
      savedAt: Date.now()
    });

    localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
  }

  saveCurrentProduct();

  window.LBRecentlyViewed = {
    get(limit = 8) {
      return getItems().slice(0, limit);
    },
    all() {
      return getItems();
    },
    clear() {
      localStorage.removeItem(KEY);
    }
  };
})();